import { render, staticRenderFns } from "./SQLReport.vue?vue&type=template&id=1f978e9b&"
import script from "./SQLReport.vue?vue&type=script&lang=js&"
export * from "./SQLReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports